import TypeUtil from '@/util/type.util.js'
export const SET_SELECTED_ARRAY = 'SET_SELECTE_ARRAY'
export const PUSH_NAV_MENU = 'PUSH_NAV_MENU'
export const POP_NAV_MENU = 'POP_NAV_MENU'
export const RESET_DEPARTMENT_STORE = 'RESET_DEPARTMENT_STORE'
export const PUSH_SELECTED_ARRAY = 'PUSH_SELECTED_ARRAY'
export const POP_SELECTED_ARRAY = 'POP_SELECTED_ARRAY'
export const REMOVE_SELECTED_ARRAY = 'REMOVE_SELECTED_ARRAY'

const departmentStore = {
  namespaced: true,
  state: {
    selectedArray: [],
    navMenu: [{
      name: '全部'
    }]
  },
  mutations: {
    [SET_SELECTED_ARRAY](state, selectedArray) {
      if (TypeUtil.isArray(selectedArray)) {
        state.selectedArray = selectedArray
      }
    },
    [PUSH_SELECTED_ARRAY](state, item) {
      if (TypeUtil.isObject(item)) {
        state.selectedArray.push(item)
      }
    },
    [POP_SELECTED_ARRAY](state) {
      state.selectedArray.pop()
    },
    [REMOVE_SELECTED_ARRAY](state, item) {
      if (TypeUtil.isObject(item)) {
        const index = state.selectedArray.findIndex(_item => _item.id === item.id)
        if (index !== -1) {
          state.selectedArray.splice(index, 1)
        }
      }
    },
    [PUSH_NAV_MENU](state, menu) {
      if (TypeUtil.isObject(menu)) {
        state.navMenu.push(menu)
      }
    },
    [POP_NAV_MENU](state) {
      state.navMenu.pop()
    },
    [RESET_DEPARTMENT_STORE](state) {
      state.selectedArray = []
      state.navMenu = [
        {
          name: '全部'
        }
      ]
    }
  }
}

export default departmentStore
